module.exports = __webpack_public_path__ + "static/img/banner-about-01.6c743d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-about-01.jpg
// module id = 3c/m
// module chunks = 98